export default {
    selfInfo: state => state.selfInfo,
    detailPlace: state => state.detailPlace,
    healthCard: state => state.healthCard,
    partiesMes: state => state.partiesMes,
    fileList: state => state.fileList,
    fileImages: state => state.fileImages,
    searchValue: state => state.searchValue
};
